module.exports = __webpack_public_path__ + "static/media/tip1.2c38d834.svg";